import { useState } from 'react';
import { SunMedium, Moon, MonitorSmartphone } from 'lucide-react';
import { getStoredTheme, setTheme as persistTheme } from '../../theme';

const OPTIONS = [
    { value: 'light', label: 'Claro', icon: SunMedium },
    { value: 'dark', label: 'Escuro', icon: Moon },
    { value: 'system', label: 'Sistema', icon: MonitorSmartphone },
];

export function ThemeCard() {
    const [theme, setThemeState] = useState(getStoredTheme());

    const choose = (value) => {
        persistTheme(value);
        setThemeState(value);
    };

    return (
        <div className="card custom-card h-100">
            <div className="card-body p-4">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <div className="icon-container">
                        <SunMedium size={16} className="text-muted-custom" />
                    </div>
                    <h3 className="h5 fw-semibold mb-0">Aparência</h3>
                </div>

                <p className="text-muted-custom small mb-3">
                    Escolha entre claro, escuro, ou siga o tema do seu sistema.
                </p>

                <div className="d-flex gap-2 flex-wrap">
                    {OPTIONS.map(({ value, label, icon: Icon }) => (
                        <button
                            key={value}
                            type="button"
                            onClick={() => choose(value)}
                            className={`btn d-flex align-items-center gap-2 ${theme === value ? 'btn-primary-custom' : 'btn-outline-custom'}`}
                        >
                            <Icon size={16} /> {label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
